import localDB from "./localDB";

let GLOBAL = require('./globals');

const IngredientStockData = {
    async listByIngredient(id) {
        let response = await fetch(`${GLOBAL.BASE_URL}api/ingredient-stock/${id}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async stock(page, pk) {
        let response = await fetch(`${GLOBAL.BASE_URL}api/ingredient-stock/${pk}?page=${page}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },

    async update(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/ingredient-stock/update`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
    /*async delete(id, res) {
        await fetch(`${GLOBAL.BASE_URL}api/product-stock/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },*/
    /*async listBranch() {
        let response = await fetch(`${GLOBAL.BASE_URL}api/product-stock-branch`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },*/
};

export default IngredientStockData;



// WEBPACK FOOTER //
// ./src/data/IngredientStockData.js